var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1267 10.7723C5.97397 10.9081 5.76559 10.9839 5.54914 10.9839C5.33268 10.9839 5.12431 10.9081 4.97158 10.7723L0.359013 6.69365C-0.119671 6.27045 -0.119671 5.58419 0.359013 5.16178L0.936574 4.65103C1.41541 4.22782 2.19073 4.22782 2.66941 4.65103L5.54914 7.19713L13.3306 0.317404C13.8094 -0.105801 14.5855 -0.105801 15.0634 0.317404L15.641 0.82816C16.1197 1.25136 16.1197 1.93749 15.641 2.36003L6.1267 10.7723Z",
    fill: "#4A3A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxTick);
export default __webpack_public_path__ + "static/media/checkbox_tick.ffa7bedaa71ef8c1f1af53354085685b.svg";
export { ForwardRef as ReactComponent };